import {dashboardApi} from "../api";
import {DashboardDTO} from "../dto";

export const dashboardService = {
    async getDashboard() {
        const res = await dashboardApi.getDashboard();
        return DashboardDTO(res?.data?.data);
    }
};
